/**
 * 点击表格的行，跳转到拼接的url
 */
import $ from "jquery"
export default {
  methods: {
    clickJumpToSpecialUrl() {
      console.log('执行插件')
      if (!this.isBigScreenPreview()) return
      let urls = []
      const urlReg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/
      function getUrlParam(str, name) {
        var reg = new RegExp("[?&]" + name + "=([^&#]+)")
        var query = str.match(reg)
        return query ? query[1] : null
      }
      console.log('this.options.listOtherData', this.options.listData.length, this.options.listOtherData)
      // 先找出fid在数组中的下标
      const index = this.options.headerData.findIndex(value => value === "fid")
      for (let i = 0; i < this.options.listData.length; i++) {
        const temp = this.options.listOtherData[i]?.url
        console.log('temp', temp)
        if (!temp) {
          return
        }
        const url = decodeURIComponent(decodeURIComponent(getUrlParam(temp, "url")))
        if (!url || url == 'null') {
          return
        }
        const proxy = urlReg.exec(url)[0] //截取域名
        const pageId = url.split("pageId=")[1]
        const fid = this.options.listData[i][index]
        urls.push(`https://${proxy}/v2/proxy/${pageId}/${fid}`)
      }
      // 给表格每行绑定点击事件
      setImmediate(() => {
        console.log('urls', urls)
        const domStr = this.$event.getIdsByStrId(this.myid)
        console.log("domStr>>>", domStr)
        const dom = $(`.${domStr} .tableComponent .item`)
        console.log("dom>>>", dom)
        dom.each(i => {
          const items = $(dom[i]).find("li")
          items.each(j => {
            items[j].addEventListener("click", event => {
              window.open(urls[j])
            })
          })
        })
      })
    }
  }
}
